
export const networkDeviceIsSimpleOnlineStatus = (label) => {
    return  !(label === "PC" ||
        label === "PC Linux" ||
        label.toLowerCase().includes('nec') ||
        label.toLowerCase().includes('optoma') ||
        label.toLowerCase().includes('pjlink') ||
        label.toLowerCase().includes('android'))
}